import {
  all,
  call,
  fork,
  put,
  takeEvery,
  select,
  takeLatest,
  take,
} from 'redux-saga/effects';
import { postRequest } from '../../helpers/api';
import { CONNECT_USER } from '../actions';
import { ConnectSuccess } from './actions';
import {
  JsonHubProtocol,
  HttpTransportType,
  HubConnectionBuilder,
  LogLevel,
} from '@microsoft/signalr';

const createConnection = async ({ params }) => {
  return await new Promise((success, fail) => {
    setTimeout(() => {
      const protocol = new JsonHubProtocol();

      // let transport to fall back to to LongPolling if it needs to
      const transport =
        HttpTransportType.WebSockets | HttpTransportType.LongPolling;

      const options = {
        transport,
        logMessageContent: true,
        logger: LogLevel.Error,
      };

      // create the connection instance
      const connection = new HubConnectionBuilder()
        .withUrl(`${process.env.REACT_APP_SIGNALR}/api`, options)
        .withHubProtocol(protocol)
        .withAutomaticReconnect()
        .build();

      // re-establish the connection if connection dropped
      connection.onclose(() =>
        setTimeout(startSignalRConnection(connection), 5000)
      );

      //startSignalRConnection(connection);
      connection.start().then(() => {
        console.info('SignalR Connected');
        success({ connection });
      });
    });
  })
    .then((response) => response)
    .catch((error) => error);
};

const startSignalRConnection = (connection) =>
  connection
    .start()
    .then(() => console.info('SignalR Connected'))
    .catch((err) => console.error('SignalR Connection Error: ', err));

function* MakeConnection(payload) {
  try {
    const response = yield call(createConnection, payload);
    yield put(ConnectSuccess(response));
  } catch (error) {}
}

export function* watchGetList() {
  yield takeLatest(CONNECT_USER, MakeConnection);
}

export default function* rootSaga() {
  yield all([fork(watchGetList)]);
}
